export type CodedError = Error & {
  cause: { statusCode: number; title: string; code?: string };
};

export const createCodedError = ({
  message,
  statusCode,
  title,
  code,
}: {
  message: string;
  statusCode: number;
  title?: string;
  code?: string;
}): CodedError => {
  return new Error(message, {
    cause: {
      statusCode,
      title,
      code,
    },
  }) as CodedError;
};

/**
 * Type-guards to check if a thrown error is an instance of CodedError.
 * Caught errors by default are of type unknown, so we must make sure the error caught is actually what we are expecting.
 */
export const isCodedError = (error: unknown): error is CodedError => {
  return error instanceof Error && 'cause' in error;
};
